import React from 'react';
import {
  Table,
  Header,
  Segment,
} from 'semantic-ui-react';

import {
  CustomContainer,
  RequiresLogin,
} from '../../common';
import {
  UserLink,
} from '../../Links';

interface RelatedIDsTableProps {
  authed: boolean;
  data: any[];
  isFetching: boolean;
  isMobile: boolean;
  title: string;
}

export default (props: RelatedIDsTableProps) => {
  const {
    authed,
    data,
    isFetching,
    isMobile,
    title,
  } = props;

  const hasData = (Array.isArray(data) && data.length > 0);

  return (
    <CustomContainer>
      <Header as={isMobile ? 'h3' : 'h2'} attached="top">
        {title}
      </Header>
      <Segment attached loading={isFetching}>
        <RequiresLogin dimmed={!authed}>
          {
            hasData ? (
              <Table celled fixed singleLine unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>重疊 IP 總數</Table.HeaderCell>
                    <Table.HeaderCell>重疊 IP 比率</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    data.map((cell: any) => (
                      <Table.Row key={cell.id}>
                        <Table.Cell>
                          <UserLink id={cell.id}>
                            {cell.id}
                          </UserLink>
                        </Table.Cell>
                        <Table.Cell>{cell.total_matched_ips}</Table.Cell>
                        <Table.Cell>
                          {(cell.matched_ratio * 100).toFixed(2)}
                          {' '}
                          %
                        </Table.Cell>
                      </Table.Row>
                    ))
                  }
                </Table.Body>
              </Table>
            ) : (
              <p>無資料 (._.)</p>
            )
          }
        </RequiresLogin>
      </Segment>
    </CustomContainer>
  );
};
